var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.792,
    height: 27.303,
    viewBox: "0 0 35.792 27.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.803,
    y1: -0.132,
    x2: 0,
    y2: 0.934,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257",
    transform: "translate(-956.875 -519.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M978.622,546.835H967.544a.544.544,0,0,1-.562-.37l-1.354-4.063H958.64a1.767,1.767,0,0,1-1.765-1.765V530.259a1.757,1.757,0,0,1,1.715-1.764h0l5.62.01a1.758,1.758,0,0,1,1.269.518l2.869,2.869h2.169a1.767,1.767,0,0,1,1.763,1.7h4.964a1.767,1.767,0,0,1,1.763-1.7h2.173l2.879-2.878a1.744,1.744,0,0,1,1.252-.518h5.591a1.766,1.766,0,0,1,1.761,1.764v10.188a1.766,1.766,0,0,1-1.764,1.763h-6.981l-1.411,4.249a.512.512,0,0,1-.528.374h-3.36Zm1.184-1.83h1.253l1.141-3.416a1.759,1.759,0,0,1,1.673-1.206h6.965v-10.06h-5.5L982.46,533.2a1.774,1.774,0,0,1-.7.43h3.982a1.765,1.765,0,0,1,1.762,1.673v1.915a1.761,1.761,0,0,1-1.694,1.826l-.069,0h-3.579Zm-14.368-7.786h1.946a1.758,1.758,0,0,1,1.639,1.109L971.692,545h6.119l2.669-6.675a1.758,1.758,0,0,1,1.645-1.11h3.555v-1.754H965.444Zm-6.733,3.351h6.965a1.762,1.762,0,0,1,1.674,1.206L968.417,545h1.3l-2.38-5.951h-1.965a1.774,1.774,0,0,1-1.768-1.66v-.028l.008-1.9a1.763,1.763,0,0,1,1.7-1.826h2.468a1.771,1.771,0,0,1-.7-.43l-2.872-2.868-5.509-.01Zm25.339-16.725a4.311,4.311,0,1,1,4.312,4.312h0A4.317,4.317,0,0,1,984.044,523.844Zm1.83,0a2.481,2.481,0,1,0,2.481-2.481h0a2.483,2.483,0,0,0-2.479,2.481Zm-29,0a4.311,4.311,0,1,1,4.311,4.312h0A4.317,4.317,0,0,1,956.875,523.844Zm1.83,0a2.481,2.481,0,1,0,2.481-2.481h0A2.483,2.483,0,0,0,958.705,523.844Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingSetting);
export default __webpack_public_path__ + "static/media/MeetingSetting.23c5c1f0f8828bb11cead2693a9391e9.svg";
export { ForwardRef as ReactComponent };